import { useApiGet } from 'mf_core/query';
import { useSiteConfig } from 'mf_core/config';
import { useTranslate } from '@im/react-localization';

export function useGetSearchSuggestions(
  isCmpWhitelisted: boolean,
  enableAISuggestions: boolean,
  isMobile: boolean,
  isCMPProductExcludedReseller: boolean
) {
  const apiGet = useApiGet<SearchResponse[]>({ isLogoutApi: true });

  // eslint-disable-next-line no-nested-ternary
  let url = enableAISuggestions
    ? '/product/v1/aisuggestedcategoryoptions'
    : isCmpWhitelisted
    ? '/product/v1/suggestedcategoryoptions'
    : '/product/v1/suggestedcategories';

  if (isMobile) url = '/product/v1/suggestedcategories';

  const { siteCode } = useSiteConfig();
  const translate = useTranslate();
  return async (term: string) => {
    const result = await apiGet(url, {
      isCMPWhitelisted: isCmpWhitelisted,
      isCloudProductEnabled: !isCMPProductExcludedReseller,
      term,
    });
    const newResult = result
      ? result.map((element) => {
          if (
            element?.category &&
            siteCode &&
            siteCode.toLowerCase() === 'it'
          ) {
            const categoryTrans = translate(`CommonSearch.${element.category}`);
            return { ...element, category: categoryTrans };
          }
          return element;
        })
      : [];
    return newResult || [];
  };
}

type Option = {
  isCloudSuggestion: boolean;
  source: string;
  suggestion: string;
};

type SearchResponse = {
  category: string;
  suggestions: string[] | Option[];
};
